import React from 'react'
import Helmet from 'react-helmet'
import marked from 'marked'

import CustomHelmet from '../components/CustomHelmet'
import Hero from '../components/ProgramOverview/Hero'
import Fellows from '../components/Fellows'
import Signup from '../components/Shared/Signup'
import ParentInterestForm from '../components/Shared/ParentInterestForm'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import Img from 'gatsby-image'
import Link from 'gatsby-link'

var ScrollMagic
if (typeof window === 'object') {
    ScrollMagic = require('scrollmagic')
}

class pageTemplate extends React.Component {
    constructor(props) {
        super()
        this.state = {
            unlocked: true
        }
    }
    componentDidMount() {
        const page = this.props.data.page.edges[0].node

        page.protectedPage ? (
            this.setState({ unlocked: false }),
            this.setupKeyListener()
        ) : this.setState({ unlocked: true })
    }
    setupKeyListener() {
        document.addEventListener('keydown', (e) => {
            const key = e.keyCode
            key === 13 ? this.unlockPage() : null
        })
    }
    unlockPage() {
        const input = this.refs.access

        input.value === this.props.data.page.edges[0].node.pageKey ? this.setState({ unlocked: true }) : null
    }
  render() {
      const { location } = this.props
    const page = this.props.data.page.edges[0].node
    const contentfulData = this.props.data.allContentfulFellowsProfile ? this.props.data.allContentfulFellowsProfile.edges[0].node : false
    // console.log('page ===> ',page)

    const cleanedPath = location.pathname.replace(/[/]/g,'')

    return (
        <div className="default-page">
            <CustomHelmet data={ page.seo } location={ location }>
            {
                page.protectedPage &&
                <meta name="robots" content="noindex" />
            }
            </CustomHelmet>
            <Hero title={ page.title } />
            {
                !this.state.unlocked &&
                <Row className="contentWrapper capper">
                    <Column width="12" style={{ paddingRight: '20px' }}>
                        <p className="text-center">To unlock this page please provide your access key below:</p>
                        <div className="access-form">
                            <input type="password" name="accessPass" ref="access" />
                            <div className="button" onClick={ () => this.unlockPage() }>
                                <p>Submit</p>
                            </div>
                        </div>
                    </Column>
                </Row>
            }
            {
                this.state.unlocked &&
                <Row className="contentWrapper capper">
                    <Column width={ page.zapierUrl ? '7' : '12' } tablet="12" style={{ paddingRight:'20px' }}>
                        { page.introText && <span dangerouslySetInnerHTML={{ __html: marked( page.introText.introText ) }} /> }
                        { page.flexSections && page.flexSections.length > 0 && page.flexSections.map( (section, index ) => (
                            <div className="section" key={ index }>
                                <Row className="no-padding section-content">
                                    <div className="inner" style={{ width: '100%' }}>
                                        { section.sectionTitle && <h2 className="h2" dangerouslySetInnerHTML={{ __html: section.sectionTitle }} /> }
                                        { section.bannerImage && <Img style={{ marginBottom:'20px' }} sizes={ section.bannerImage.sizes } alt={ section.bannerImage.description } /> }
                                        { section.sectionItems.length && section.sectionItems.map( (item, index) => (
                                        <div key={ index }>
                                                <div className="section-group">
                                            {
                                                item.title &&
                                                <h3 className="h3" dangerouslySetInnerHTML={{ __html: item.title }} />
                                            }
                                            {
                                                item.text &&
                                                <p dangerouslySetInnerHTML={{ __html: marked(item.text.text) }} />
                                            }
                                            </div>

                                            <div className="section-group">
                                                { item.question && <h3 className="h3" dangerouslySetInnerHTML={{ __html: item.question }} /> }
                                                { item.answer && <p dangerouslySetInnerHTML= {{ __html: marked(item.answer.answer) }} /> }
                                            </div>
                                        </div>

                                        ))}
                                    </div>
                                </Row>
                            </div>
                        ))}
                    </Column>
                    {
                        page.zapierUrl && cleanedPath !== 'parent-request-info' &&
                        <Column ref={ (ref) => { this.col = ref }} width="5" tablet="12">
                            <Signup
                              title="REQUEST INFORMATION"
                              description=""
                              zap={page.zapierUrl}
                              fieldKey={page.hiddenFieldKey}
                              fieldValue={page.hiddenFieldValue}
                            />
                        </Column>
                    }
                    {
                        page.zapierUrl && cleanedPath === 'parent-request-info' &&
                        <Column ref={ (ref) => { this.col = ref }} width="5" tablet="12">
                            <ParentInterestForm
                              title="REQUEST INFORMATION"
                              description=""
                              zap={page.zapierUrl}
                              fieldKey={page.hiddenFieldKey}
                              fieldValue={page.hiddenFieldValue}
                            />
                        </Column>
                    }

                    { page.link &&
                        <Link style={{ marginTop:'30px' }} className="hoverlink" to={ page.link.link }>{ page.link.text }</Link>
                    }
                </Row>
            }
            {
                this.state.unlocked && page.fellows && page.fellows.title &&
                <Row className="no-top-padding no-bottom-padding">
                    <Column width="12">
                        <Fellows
                          title={page.fellows.title}
                          cards={page.fellows.fellowsCards}
                          link={page.fellows.link}
                        />
                    </Column>
                </Row>
            }
        </div>
    )
  }
}

export default pageTemplate

export const query = graphql`
query pageQuery($id: String!) {
    page: allContentfulDefaultPageTemplate(filter:{ id: { eq: $id }}) {
        edges {
			node {
                id
                title
                slug
                link {
                    link
                    text
                }
                zapierUrl
                hiddenFieldKey
                hiddenFieldValue
                protectedPage
                pageKey
                introText {
                    introText
                }
                flexSections {
                  sectionTitle
                  bannerImage {
                      sizes(quality:100, maxWidth:1800) {
                          ...GatsbyContentfulSizes_withWebp
                      }
                      file {
                          url
                      }
                  }
                  sectionItems {
                      __typename
                    ...on ContentfulFaqItem {
                      __typename
                      question
                      answer {
                        answer
                      }
                    }
                    ...on ContentfulTitleText {
                      __typename
                      title
                      text {
                        text
                      }
                    }
                  }
                }
                fellows: bottomSlider {
                    title
                    link {
                      text
                      link
                    }
                    fellowsCards {
                      storyPosition
                      storyLocation
                      quoteTitle
                      attribution
                      quoteText
                      link
                      articleImage {
                        sizes(quality:100, maxWidth:400) {
                              ...GatsbyContentfulSizes_withWebp
                        }
                        file {
                          url
                        }
                        title
                      }
                    }
                }
                seo: seoData {
                  pageTitle
                  pageDescription {
                    pageDescription
                  }
                  keywords
                  openGraphTitle
                  openGraphDescription {
                    openGraphDescription
                  }
                  openGraphImage {
                    file {
                      url
                    }
                  }
                }
            }
        }
    }
}
`



// WEBPACK FOOTER //
// ./src/templates/page.js